import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { MetricDefinitionCalibrationFraming } from 'libs/end-to-end/src/types/databases/metrics/metric-definition-calibration-framing';

export const defaultCalibrationFramingMapping: Record<
  FocusArea,
  MetricDefinitionCalibrationFraming
> = {
  Attrition: 'Negative',
  Promotion: 'Positive',
  Performance: 'Positive',
  Engagement: 'Positive',
  Hiring: 'Positive',
  Leadership: 'Positive',
  Compensation: 'Positive',
};
